import ActionCable from 'actioncable'
import FlashMessages from 'lib/flash-messages'
import moment from 'lib/moment-timezone-custom'
import webP from 'lib/test-webp'
webP.setCSSClass()

export default class AppBase {
  static init () {
    this.setupAjax()
    this.initActionCable()
    this.handleDocumentLoading()
    this.touchDetect()
    this.initialized = true
  }

  static initActionCable () {
    if (window.WebSocket) {
      this.cable = ActionCable.createConsumer()
    } else {
      console.warn('initActionCable(): WebSocket not available')
    }
  }

  static handleDocumentLoading () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.handleDOMReady.bind(this))
    } else {
      setTimeout(() => { this.handleDOMReady() }, 0)
    }

    if (document.readyState === 'complete') {
      setTimeout(() => { this.checkStyles() }, 100)
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => { this.checkStyles() }, 100)
      })
    }
  }

  static checkStyles () {
    if (this.stylesApplied) {
      if (this.checkStylesIntervalId) {
        clearInterval(this.checkStylesIntervalId)
        this.checkStylesIntervalId = null
      }

      if (!this.stylesAppliedEventDispatched) {
        this.stylesAppliedEventDispatched = true
        this.handleStylesApplied()
        console.debug('[App] checkStyles(): triggering app:styles:applied')
        document.dispatchEvent(new CustomEvent('app:styles:applied'))
      }
    } else if (this.checkStylesIntervalId === undefined) {
      console.debug('[App] checkStyles(): not applied yet, setting interval')
      this.checkStylesIntervalId = setInterval(this.checkStyles.bind(this), 100)
    } else {
      console.debug('[App] checkStyles(): not applied yet...')
    }
  }

  static get stylesApplied () {
    return this.checkpointEl && window.getComputedStyle(this.checkpointEl).display === 'none'
  }

  static get checkpointEl () {
    return this._checkpointEl || (this._checkpointEl = document.getElementById('checkpoint_el'))
  }

  static handleDOMReady () {
    if (this.DOMReadyHandled) return
    this.DOMReadyHandled = true
    console.debug('[App] handleDOMReady')
    this.loadSettings()
    FlashMessages.render()
    if (!moment.defaultZone) console.error('App#handleDOMReady: moment.tz.setDefault failed')
    this.disabledLinks()
    if (typeof inlineRender === 'function') window.inlineRender()
  }

  static handleStylesApplied () {
    console.debug('[App] handleStylesApplied()')
  }

  // ApplicationHelper#conditional_link_to disabled links
  static disabledLinks () {
    function handler (ev) {
      if (ev.target.tagName === 'A' && ev.target.dataset.disabled) {
        ev.stopImmediatePropagation()
        ev.preventDefault()
      }
    }

    document.addEventListener('click', handler, true)
  }

  static loadSettings () {
    if (document.body.dataset.settings) {
      this.settings = JSON.parse(document.body.dataset.settings)
    } else {
      this.settings = {}
    }
  }

  static setupAjax () {
    const tokenTag = document.querySelector('meta[name="csrf-token"]')
    if (typeof $ !== 'undefined') {
      // eslint-disable-next-line no-undef
      $.ajaxSetup({ headers: { 'X-CSRF-Token': tokenTag && tokenTag.attributes.content.value } })
    }
  }

  static touchDetect () {
    this.touchDetected = false
    this.handleFirstTouch = this.handleFirstTouch.bind(this)
    window.addEventListener('touchstart', this.handleFirstTouch, false)
  }

  static handleFirstTouch () {
    this.touchDetected = true
    console.debug('[App] handleFirstTouch(): touchDetected = true')
    window.removeEventListener('touchstart', this.handleFirstTouch, false)
  }

  static get env () { return process.env.RAILS_ENV }

  static get current () {
    return this._current
  }

  static set current (value) {
    this._current = value
  }
}
